/* eslint-disable react/button-has-type */
import React, { useState, useRef, useCallback } from 'react';
import { Global, css } from '@emotion/react';

const globalStyles = css`
  .dhub * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  .dhub {
    font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
    background: #faf9f7;
    color: #1a1a1a;
    min-height: 100vh;
  }
  .dhub .app {
    max-width: 860px;
    margin: 0 auto;
    padding: 0 0 48px;
  }
  .dhub .nav {
    background: #fff;
    border-bottom: 1px solid #e8e4df;
    padding: 0 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .dhub .nav-logo {
    font-family: 'Georgia', serif;
    font-size: 17px;
    font-weight: 400;
    color: #1a1a1a;
    padding: 16px 0;
  }
  .dhub .nav-right {
    font-size: 12px;
    color: #9a9087;
  }
  .dhub .page-header {
    padding: 36px 32px 0;
  }
  .dhub .page-eyebrow {
    font-size: 10px;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #9a9087;
    margin-bottom: 10px;
  }
  .dhub .page-title {
    font-family: 'Georgia', serif;
    font-size: 28px;
    font-weight: 400;
    color: #1a1a1a;
    margin-bottom: 8px;
    letter-spacing: -0.01em;
  }
  .dhub .page-sub {
    font-size: 13px;
    color: #9a9087;
    line-height: 1.6;
    max-width: 520px;
    margin-bottom: 28px;
  }
  .dhub .tabs {
    display: flex;
    border-bottom: 1px solid #e8e4df;
    padding: 0 32px;
    margin-bottom: 32px;
  }
  .dhub .tab {
    font-size: 13px;
    padding: 10px 18px 14px;
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    color: #9a9087;
    margin-bottom: -1px;
    font-family: inherit;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .dhub .tab.active {
    color: #1a1a1a;
    border-bottom-color: #1a1a1a;
  }
  .dhub .tab:hover:not(.active) {
    color: #1a1a1a;
  }
  .dhub .rest-badge {
    font-size: 10px;
    font-weight: 600;
    background: #fdecea;
    color: #a33;
    border-radius: 20px;
    padding: 2px 7px;
  }
  .dhub .progress-section {
    padding: 0 32px;
    margin-bottom: 28px;
  }
  .dhub .progress-top {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 8px;
  }
  .dhub .progress-label {
    font-size: 12px;
    color: #1a1a1a;
    font-weight: 500;
  }
  .dhub .progress-count {
    font-size: 12px;
    color: #9a9087;
  }
  .dhub .progress-track {
    height: 5px;
    background: #e8e4df;
    border-radius: 3px;
    overflow: hidden;
  }
  .dhub .progress-fill {
    height: 5px;
    background: #1a1a1a;
    border-radius: 3px;
    transition: width 0.4s;
  }
  .dhub .req-list {
    padding: 0 32px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .dhub .req-card {
    background: #fff;
    border: 1px solid #e0dbd4;
    border-radius: 12px;
    padding: 18px 20px;
    display: flex;
    align-items: flex-start;
    gap: 16px;
    transition:
      border-color 0.15s,
      box-shadow 0.3s;
  }
  .dhub .req-card:hover {
    border-color: #c5bfb8;
  }
  .dhub .req-card.done {
    border-left: 3px solid #6b9e5e;
  }
  .dhub .req-card.pending {
    border-left: 3px solid #e8a838;
  }
  .dhub .req-card.not-required {
    border-left: 3px solid #e0dbd4;
    opacity: 0.7;
  }
  .dhub .req-card.highlighted {
    box-shadow: 0 0 0 2px #1a1a1a;
  }
  .dhub .req-icon {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1px;
  }
  .dhub .icon-done {
    background: #e8f2e5;
  }
  .dhub .icon-pending {
    background: #fff8ec;
  }
  .dhub .icon-not-required {
    background: #f3f0eb;
  }
  .dhub .check {
    width: 14px;
    height: 10px;
    border-left: 2px solid #6b9e5e;
    border-bottom: 2px solid #6b9e5e;
    transform: rotate(-45deg) translate(1px, -1px);
  }
  .dhub .clock {
    width: 14px;
    height: 14px;
    border: 2px solid #e8a838;
    border-radius: 50%;
    position: relative;
  }
  .dhub .clock::after {
    content: '';
    position: absolute;
    top: 1px;
    left: 5px;
    width: 2px;
    height: 5px;
    background: #e8a838;
  }
  .dhub .minus {
    width: 10px;
    height: 2px;
    background: #9a9087;
    border-radius: 1px;
  }
  .dhub .req-content {
    flex: 1;
    min-width: 0;
  }
  .dhub .req-title {
    font-size: 14px;
    font-weight: 500;
    color: #1a1a1a;
    margin-bottom: 4px;
  }
  .dhub .req-desc {
    font-size: 12px;
    color: #9a9087;
    line-height: 1.5;
    margin-bottom: 10px;
  }
  .dhub .req-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .dhub .req-pill {
    font-size: 10px;
    padding: 3px 10px;
    border-radius: 20px;
    letter-spacing: 0.02em;
  }
  .dhub .pill-done {
    background: #e8f2e5;
    color: #4a7a3e;
  }
  .dhub .pill-pending {
    background: #fff8ec;
    color: #a06000;
  }
  .dhub .pill-not-required {
    background: #f3f0eb;
    color: #9a9087;
  }
  .dhub .req-cta {
    font-size: 12px;
    padding: 7px 18px;
    border-radius: 100px;
    cursor: pointer;
    transition: all 0.15s;
    font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
  }
  .dhub .req-cta.ghost {
    background: none;
    border: 1.5px solid #e0dbd4;
    color: #1a1a1a;
  }
  .dhub .req-cta.ghost:hover {
    border-color: #1a1a1a;
  }
  .dhub .req-cta.primary {
    background: #1a1a1a;
    border: 1.5px solid #1a1a1a;
    color: #faf9f7;
  }
  .dhub .req-cta.primary:hover {
    background: #333;
  }
  .dhub .req-cta:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .dhub .summary {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    padding: 0 32px;
    margin-bottom: 28px;
  }
  .dhub .sum-card {
    background: #fff;
    border: 1px solid #e0dbd4;
    border-radius: 10px;
    padding: 14px 16px;
    text-align: center;
  }
  .dhub .sum-val {
    font-family: 'Georgia', serif;
    font-size: 24px;
    font-weight: 400;
    color: #1a1a1a;
    margin-bottom: 3px;
  }
  .dhub .sum-lbl {
    font-size: 11px;
    color: #9a9087;
    letter-spacing: 0.03em;
  }
  .dhub .rest-wrap {
    padding: 0 32px;
  }
  .dhub .rest-summary {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    margin-bottom: 24px;
  }
  .dhub .restriction-card {
    background: #fff;
    border: 1px solid #e0dbd4;
    border-radius: 12px;
    padding: 18px 20px;
    margin-bottom: 10px;
    border-left: 3px solid #e8a838;
  }
  .dhub .restriction-card.severe {
    border-left-color: #c0392b;
  }
  .dhub .restriction-card.resolved {
    border-left-color: #6b9e5e;
    opacity: 0.7;
  }
  .dhub .rest-top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 8px;
  }
  .dhub .rest-title {
    font-size: 14px;
    font-weight: 500;
    color: #1a1a1a;
    margin-bottom: 3px;
  }
  .dhub .rest-date {
    font-size: 11px;
    color: #9a9087;
  }
  .dhub .rest-desc {
    font-size: 12px;
    color: #9a9087;
    line-height: 1.5;
    margin-bottom: 12px;
  }
  .dhub .rest-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
  }
  .dhub .rest-req {
    font-size: 11px;
    color: #9a9087;
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
  }
  .dhub .rest-req-label {
    font-size: 10px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #9a9087;
    margin-right: 2px;
  }
  .dhub .req-tag {
    font-size: 11px;
    padding: 2px 9px;
    border-radius: 20px;
    background: #f3f0eb;
    color: #1a1a1a;
    border: 1px solid #e0dbd4;
  }
  .dhub .sev-pill {
    font-size: 10px;
    padding: 3px 9px;
    border-radius: 20px;
    display: inline-block;
    white-space: nowrap;
    flex-shrink: 0;
  }
  .dhub .sev-high {
    background: #fdecea;
    color: #a33;
  }
  .dhub .sev-medium {
    background: #fff8ec;
    color: #a06000;
  }
  .dhub .sev-resolved {
    background: #e8f2e5;
    color: #4a7a3e;
  }
  .dhub .resolved-label {
    font-size: 10px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #9a9087;
    margin: 24px 0 10px;
  }
  .dhub .empty-state {
    text-align: center;
    padding: 48px 0;
  }
  .dhub .empty-state p {
    font-family: 'Georgia', serif;
    font-size: 16px;
    color: #1a1a1a;
    margin-bottom: 6px;
  }
  .dhub .empty-state span {
    font-size: 12px;
    color: #9a9087;
  }
  .dhub .placeholder-tab {
    padding: 48px 32px;
    text-align: center;
    color: #9a9087;
    font-size: 13px;
  }
`;

type Status = 'done' | 'pending' | 'not-required';
type Severity = 'high' | 'medium' | 'resolved';
type TabId = 'setup' | 'restrictions' | 'reputation' | 'guides';
type Req = { id: string; title: string; desc: string; status: Status; cta: string | null };
type Restriction = {
  id: string;
  title: string;
  desc: string;
  severity: Severity;
  since: string;
  requirements: string[];
  status: 'active' | 'resolved';
};

const REQS: Req[] = [
  {
    id: 'domain',
    title: 'Custom domain verification',
    desc: "Connect your own sending domain to improve inbox placement and build trust with your subscribers' email providers.",
    status: 'done',
    cta: 'View setup',
  },
  {
    id: 'postmaster',
    title: 'Google Postmaster integration',
    desc: 'Link Google Postmaster Tools so we can monitor your domain reputation and alert you before issues affect your Gmail delivery.',
    status: 'pending',
    cta: 'Connect now',
  },
  {
    id: 'optin',
    title: 'Enable double opt-in for forms',
    desc: 'Ask new subscribers to confirm their email before joining your list. This keeps your list healthy and your open rates high.',
    status: 'pending',
    cta: 'Go to forms',
  },
  {
    id: 'segments',
    title: 'Create smart segments',
    desc: 'Organise your audience by engagement so you can send to the right people at the right time — and protect your sending reputation.',
    status: 'done',
    cta: 'View segments',
  },
  {
    id: 'unengaged',
    title: 'Remove or archive unengaged subscribers',
    desc: "Sending to inactive contacts hurts your deliverability. We'll help you identify and clean them up in just a few steps.",
    status: 'pending',
    cta: 'Clean my list',
  },
  {
    id: 'kyc',
    title: 'Identity verification (KYC)',
    desc: 'Verify your identity to unlock higher sending volumes and keep your account in good standing with email providers.',
    status: 'not-required',
    cta: null,
  },
];

const RESTRICTIONS: Restriction[] = [
  {
    id: 'r1',
    title: 'High hard bounce due to inactive subscribers',
    desc: 'A high number of your recent emails bounced because they were sent to inactive or invalid addresses. Cleaning your list will help bring your bounce rate back to a healthy level.',
    severity: 'medium',
    since: 'Mar 15, 2026',
    requirements: ['Remove or archive unengaged subscribers', 'Enable double opt-in for forms'],
    status: 'active',
  },
  {
    id: 'r2',
    title: 'High bounce due to low sending domain reputation',
    desc: "Your sending domain has a low reputation with major email providers, causing a high bounce rate. You'll need to verify your domain, complete KYC, and connect Google Postmaster before sending is permitted.",
    severity: 'high',
    since: 'Mar 13, 2026',
    requirements: [
      'Google Postmaster integration',
      'Custom domain verification',
      'Complete KYC process',
    ],
    status: 'active',
  },
  {
    id: 'r3',
    title: 'Custom domain authentication required',
    desc: 'Your account is sending from a shared domain. To unlock full sending capabilities, you must authenticate your own custom domain with SPF, DKIM, and DMARC.',
    severity: 'medium',
    since: 'Mar 10, 2026',
    requirements: ['Custom domain verification'],
    status: 'active',
  },
  {
    id: 'r4',
    title: 'In-progress campaign cancelled',
    desc: 'An active campaign was halted on Mar 8 due to a spam rate spike. Your next send will require completing the steps listed below.',
    severity: 'high',
    since: 'Mar 8, 2026',
    requirements: [
      'Remove or archive unengaged subscribers',
      'Enable double opt-in for forms',
      'Custom domain verification',
    ],
    status: 'active',
  },
  {
    id: 'r5',
    title: 'KYC verification completed — restriction lifted',
    desc: 'Your identity verification was completed successfully. Sending limits related to this requirement have been removed.',
    severity: 'resolved',
    since: 'Feb 28, 2026',
    requirements: [],
    status: 'resolved',
  },
];

function ReqIcon({ status }: { status: Status }) {
  if (status === 'done')
    return (
      <div className="req-icon icon-done">
        <div className="check" />
      </div>
    );
  if (status === 'pending')
    return (
      <div className="req-icon icon-pending">
        <div className="clock" />
      </div>
    );
  return (
    <div className="req-icon icon-not-required">
      <div className="minus" />
    </div>
  );
}

function ReqPill({ status }: { status: Status }) {
  if (status === 'done') return <span className="req-pill pill-done">Done</span>;
  if (status === 'pending') return <span className="req-pill pill-pending">Pending</span>;
  return <span className="req-pill pill-not-required">Not required</span>;
}

function ReqCard({ req, highlighted }: { req: Req; highlighted: boolean }) {
  const [loading, setLoading] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout>>();

  const handleClick = () => {
    setLoading(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setLoading(false), 1800);
  };

  return (
    <div className={`req-card ${req.status}${highlighted ? ' highlighted' : ''}`}>
      <ReqIcon status={req.status} />
      <div className="req-content">
        <div className="req-title">{req.title}</div>
        <div className="req-desc">{req.desc}</div>
        <div className="req-footer">
          <ReqPill status={req.status} />
          {req.cta && req.status !== 'not-required' && (
            <button
              className={`req-cta ${req.status === 'done' ? 'ghost' : 'primary'}`}
              onClick={handleClick}
              disabled={loading}
            >
              {loading ? 'Redirecting…' : req.cta}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

function getCardClass(r: Restriction): string {
  if (r.severity === 'high') return 'severe';
  if (r.status === 'resolved') return 'resolved';
  return '';
}
function getSevClass(severity: Severity): string {
  if (severity === 'high') return 'sev-high';
  if (severity === 'medium') return 'sev-medium';
  return 'sev-resolved';
}
function getSevLabel(severity: Severity): string {
  if (severity === 'high') return 'High severity';
  if (severity === 'medium') return 'Medium severity';
  return 'Resolved';
}

function RestrictionCard({ r, onResolve }: { r: Restriction; onResolve: (id: string) => void }) {
  const cardClass = getCardClass(r);
  const sevClass = getSevClass(r.severity);
  const sevLabel = getSevLabel(r.severity);

  return (
    <div className={`restriction-card ${cardClass}`}>
      <div className="rest-top">
        <div>
          <div className="rest-title">{r.title}</div>
          <div className="rest-date">Since {r.since}</div>
        </div>
        <span className={`sev-pill ${sevClass}`}>{sevLabel}</span>
      </div>
      <div className="rest-desc">{r.desc}</div>
      <div className="rest-footer">
        <div className="rest-req">
          {r.requirements.length > 0 ? (
            <>
              <span className="rest-req-label">Required to lift:</span>
              {r.requirements.map(req => (
                <span key={req} className="req-tag">
                  {req}
                </span>
              ))}
            </>
          ) : (
            <span style={{ color: '#6b9e5e' }}>No further action needed</span>
          )}
        </div>
        {r.status === 'active' && (
          <button className="req-cta primary" onClick={() => onResolve(r.id)}>
            Resolve now
          </button>
        )}
      </div>
    </div>
  );
}

export default function DeliverabilityHub() {
  const [activeTab, setActiveTab] = useState<TabId>('setup');
  const [highlightedReqs, setHighlightedReqs] = useState<Set<string>>(new Set());
  const cardRefs = useRef<Record<string, HTMLDivElement | null>>({});

  const done = REQS.filter(r => r.status === 'done').length;
  const countable = REQS.filter(r => r.status !== 'not-required').length;
  const pending = REQS.filter(r => r.status === 'pending').length;
  const notRequired = REQS.filter(r => r.status === 'not-required').length;
  const pct = Math.round((done / countable) * 100);

  const activeRestrictions = RESTRICTIONS.filter(r => r.status === 'active');
  const resolvedRestrictions = RESTRICTIONS.filter(r => r.status === 'resolved');

  const handleResolveNow = useCallback((id: string) => {
    const restriction = RESTRICTIONS.find(r => r.id === id);
    if (!restriction) return;
    setActiveTab('setup');
    setTimeout(() => {
      const matchedIds = new Set<string>();
      restriction.requirements.forEach(reqName => {
        const match = REQS.find(r =>
          r.title.toLowerCase().includes(reqName.toLowerCase().split(' ').slice(0, 3).join(' ')),
        );
        if (match) matchedIds.add(match.id);
      });
      setHighlightedReqs(matchedIds);
      const firstId = [...matchedIds][0];
      if (firstId && cardRefs.current[firstId]) {
        cardRefs.current[firstId]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      setTimeout(() => setHighlightedReqs(new Set()), 2000);
    }, 100);
  }, []);

  return (
    <div className="dhub">
      <Global styles={globalStyles} />
      <div className="app">
        <div className="nav">
          <div className="nav-logo">flodesk</div>
          <div className="nav-right">Hi, Sarah ↓</div>
        </div>

        <div className="page-header">
          <div className="page-eyebrow">Account health</div>
          <div className="page-title">Deliverability hub</div>
          <div className="page-sub">
            Here&apos;s everything you need to set up your account for great inbox placement.
            Complete each step to make sure your emails land where they should.
          </div>
        </div>

        <div className="tabs">
          <button
            className={`tab${activeTab === 'setup' ? ' active' : ''}`}
            onClick={() => setActiveTab('setup')}
          >
            Sender setup requirements
          </button>
          <button
            className={`tab${activeTab === 'restrictions' ? ' active' : ''}`}
            onClick={() => setActiveTab('restrictions')}
          >
            Current restrictions <span className="rest-badge">{activeRestrictions.length}</span>
          </button>
          <button
            className={`tab${activeTab === 'reputation' ? ' active' : ''}`}
            onClick={() => setActiveTab('reputation')}
          >
            Sending reputation
          </button>
          <button
            className={`tab${activeTab === 'guides' ? ' active' : ''}`}
            onClick={() => setActiveTab('guides')}
          >
            Guides &amp; resources
          </button>
        </div>

        {activeTab === 'setup' && (
          <>
            <div className="summary">
              <div className="sum-card">
                <div className="sum-val" style={{ color: '#4a7a3e' }}>
                  {done}
                </div>
                <div className="sum-lbl">Completed</div>
              </div>
              <div className="sum-card">
                <div className="sum-val" style={{ color: '#a06000' }}>
                  {pending}
                </div>
                <div className="sum-lbl">Pending</div>
              </div>
              <div className="sum-card">
                <div className="sum-val" style={{ color: '#9a9087' }}>
                  {notRequired}
                </div>
                <div className="sum-lbl">Not required</div>
              </div>
            </div>
            <div className="progress-section">
              <div className="progress-top">
                <span className="progress-label">Setup progress</span>
                <span className="progress-count">
                  {done} of {countable} completed
                </span>
              </div>
              <div className="progress-track">
                <div className="progress-fill" style={{ width: `${pct}%` }} />
              </div>
            </div>
            <div className="req-list">
              {REQS.map(r => (
                <div
                  key={r.id}
                  ref={el => {
                    cardRefs.current[r.id] = el;
                  }}
                >
                  <ReqCard req={r} highlighted={highlightedReqs.has(r.id)} />
                </div>
              ))}
            </div>
          </>
        )}

        {activeTab === 'restrictions' && (
          <div className="rest-wrap">
            <div className="rest-summary">
              <div className="sum-card">
                <div className="sum-val" style={{ color: '#a33' }}>
                  {activeRestrictions.filter(r => r.severity === 'high').length}
                </div>
                <div className="sum-lbl">High severity</div>
              </div>
              <div className="sum-card">
                <div className="sum-val" style={{ color: '#a06000' }}>
                  {activeRestrictions.filter(r => r.severity === 'medium').length}
                </div>
                <div className="sum-lbl">Medium severity</div>
              </div>
              <div className="sum-card">
                <div className="sum-val" style={{ color: '#4a7a3e' }}>
                  {resolvedRestrictions.length}
                </div>
                <div className="sum-lbl">Resolved</div>
              </div>
            </div>
            {activeRestrictions.length === 0 ? (
              <div className="empty-state">
                <p>No active restrictions</p>
                <span>Your account is in good standing.</span>
              </div>
            ) : (
              activeRestrictions.map(r => (
                <RestrictionCard key={r.id} r={r} onResolve={handleResolveNow} />
              ))
            )}
            {resolvedRestrictions.length > 0 && (
              <>
                <div className="resolved-label">Resolved</div>
                {resolvedRestrictions.map(r => (
                  <RestrictionCard key={r.id} r={r} onResolve={handleResolveNow} />
                ))}
              </>
            )}
          </div>
        )}

        {activeTab === 'reputation' && (
          <div className="placeholder-tab">Sending reputation — coming soon</div>
        )}
        {activeTab === 'guides' && (
          <div className="placeholder-tab">Guides &amp; resources — coming soon</div>
        )}
      </div>
    </div>
  );
}
